import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Button } from '@material-ui/core'
import ListItem from './ListItem'
import NewItemDialog from './NewItemDialog/NewItemDialog'

const interfaces = {
    mbox: {
        type: 'mbox',
        complexity: 'standard',
        value: 0,
        avgLength: 0,
        profiles: 1,
        factor: 2.5,
        s3Downloads: 0,
        bitrate: 1.5
    },
    quicklink: {
        type: 'quicklink',
        value: 0,
        avgLength: 0,
        downloads: 0,
        downloadFactor: 1
    },
    mobileUpload: {
        type: 'mobileUpload',
        mediaLength: 0,
        numberOfFiles: 0
    }
}
const DynamicList = ({ items, onChange, onRemove }) => {
    const [dialog, setDialog] = useState(false)
    const [itemCount, setItemCount] = useState(0)

    const getSliderId = (type) => {
        return `${type}-slider-item-${itemCount}`
    }

    const editItems = (callback) => {
        const next = { ...items }
        callback(next)
        onChange(next)
    }

    const addNewItem = (type, complexity) => {
        setItemCount(itemCount + 1)
        editItems(
            (items) =>
                (items[getSliderId(type)] = {
                    ...interfaces[type],
                    complexity
                })
        )
    }

    return (
        <div>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => setDialog(true)}
                >
                    Add item
                </Button>

                <Button variant="outlined" color="secondary" onClick={onRemove}>
                    Remove block
                </Button>
            </div>

            {Object.keys(items)
                .map((key) => {
                    const item = items[key]
                    return (
                        <ListItem
                            {...item}
                            onChange={(callback) =>
                                editItems((items) => callback(items[key]))
                            }
                            remove={() => {
                                editItems((items) => delete items[key])
                            }}
                            key={key}
                        />
                    )
                })
                .reduceRight((acc, item) => {
                    acc.push(item)
                    return acc
                }, [])}

            <NewItemDialog
                dialog={dialog}
                setDialog={(dialog) => setDialog(dialog)}
                createItem={(type, complexity) => addNewItem(type, complexity)}
            />
        </div>
    )
}

DynamicList.propTypes = {
    onChange: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired,
    items: PropTypes.object.isRequired
}

export default DynamicList
